import packageJson from '../../../package.json'

const Version = () =><span style={{color: 'rgba(0, 0, 0, 0.54)', textAlign: 'right', marginTop: '5px'}}>v{packageJson.version}</span>

export default Version